module.exports = __webpack_public_path__ + "img/Fin-Whale.57f2ac63.png";